import { render, staticRenderFns } from "./DurationPickerModal.vue?vue&type=template&id=2a08e575&"
import script from "./DurationPickerModal.vue?vue&type=script&lang=js&"
export * from "./DurationPickerModal.vue?vue&type=script&lang=js&"
import style0 from "./DurationPickerModal.vue?vue&type=style&index=0&id=2a08e575&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports